import i18n from '../i18n/i18n';
import { showErrorToast } from './toast';
import { AxiosError } from 'axios';
import { AppError } from '../errors/appError.types';
import { createAppError } from '../errors/ErrorFactory';

export function handleAppError(error: AppError): void {
  switch (error.kind) {
    case 'validation':
      return;
    case 'auth':
      showErrorToast(i18n.t('errors.401'));
      return;
    case 'forbidden':
      showErrorToast(i18n.t('errors.403'));
      return;
    case 'notFound':
      showErrorToast(i18n.t('errors.404'));
      return;
    case 'server':
      showErrorToast(i18n.t('errors.500'));
      return;
    case 'network':
      showErrorToast(i18n.t('errors.network'));
      return;
    case 'unknown':
    default:
      showErrorToast(i18n.t('errors.default', { statusText: error.message }));
  }
}

export class ErrorManager {
  static handle(error: AxiosError | Error | unknown): void {
    const appError = createAppError(error);
    handleAppError(appError);
  }
}
